<template lang='pug'>
  div
    span Subscribe to our newsletter
    form#subscribe.bionicmetrics-subscribe-container(v-on:submit.prevent='go')
      v-text-field(label='Your email address' solo v-model='email' required)
      v-btn.bionicmetrics-subscribe-button(type='submit' text icon color='success' :loading='loading')
        v-icon send
</template>

<script>
import System from '../api/system';
import Notifications from '../services/notification.service';

export default {
  name: 'Subscribe',
  methods: {
    thanks() {
      this.email = '';
      Notifications.alert('Thanks for subscribing!');
    },
    async go() {
      try {
        this.loading = true;
        await System.subscribe(this.email);
        this.thanks();
      } catch (e) {
        Notifications.alert(`<strong>${this.email}</strong> appears to be an invalid email.`);
      } finally {
        this.loading = false;
      }
    }
  },
  data() {
    return {
      email: '',
      message: 'Thanks for subscribing!',
      loading: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bionicmetrics-subscribe-container {
    position: relative;
  }

  .bionicmetrics-subscribe-button {
    position: absolute;
    right: 0;
    top: 6px;
  }
</style>
